import { useState } from "react";
import { Mail, Send, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function NewsletterBox() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      setDone(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Моля въведете валиден имейл.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="overflow-hidden rounded-2xl bg-slate-900 px-6 py-10 sm:px-10"
      data-testid="newsletter-box"
    >
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center md:flex-row md:text-left">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-primary">
          <Mail className="h-7 w-7 text-white" />
        </div>
        <div className="flex-1">
          <h2 className="font-display text-2xl font-extrabold text-white">
            Седмичен бюлетин на Подуяне
          </h2>
          <p className="mt-1 text-sm text-slate-300">
            Най-важното от квартала веднъж седмично във Вашата поща. Без спам.
          </p>
        </div>

        {done ? (
          <div
            className="flex items-center gap-2 rounded-full bg-green-500/15 px-4 py-3 text-sm font-semibold text-green-300"
            data-testid="newsletter-success"
          >
            <CheckCircle2 className="h-5 w-5" />
            Успешно записване!
          </div>
        ) : (
          <form onSubmit={submit} className="flex w-full max-w-sm items-center gap-2 md:w-auto">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="вашият@имейл.bg"
              data-testid="newsletter-email"
              className="w-full rounded-full border border-slate-700 bg-slate-800 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-primary md:w-56"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-btn"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#0041A8] disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
              Абонирай се
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
